module.exports = __webpack_public_path__ + "img/commande-icon.f4c37789.png";